import { Pipe, PipeTransform } from '@angular/core';

import { COUNTRIES } from '../constants';
import { ECountry } from '../models';
import { ICompany } from 'app/core/interfaces';

@Pipe({ name: 'pCurrency' })
export class PCurrencyPipe implements PipeTransform {
  transform(amount: number | string, company?: any): string {
    if (!company)
      return `${COUNTRIES[ECountry.COLOMBIA].currencyCode} ${
        COUNTRIES[ECountry.COLOMBIA].currencyCode
      }---`;

    const { currencyCode, currencySymbol } =
      company || COUNTRIES[ECountry.COLOMBIA];

    const formatter = new Intl.NumberFormat('en-US', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    });

    if (amount === null || amount === undefined)
      return `${currencyCode} ${currencySymbol}---`;

    return `${currencyCode} ${currencySymbol}${formatter.format(
      Number(amount),
    )}`;
  }
}
